'use client';
import { Form, Formik } from 'formik';
import { toFormikValidationSchema } from 'zod-formik-adapter';
import { Lang } from '../../../../../utils/types';
import { languageSchema, LanguageSchema } from './schema';
import SelectInput from '../../../../inputs/SelectInput';
import useChangeLanguage from './useChangeLanguage';
import { useTenant } from '../../../../../providers/tenant/TenantProvider';
import { useLocale, useTranslate } from '@jd/i18n';

type Props = {
  alwaysOn?: boolean;
};

const localeMap: Record<string, string> = {
  pl: 'Polski',
  en: 'English',
};

const LanguageSelect = ({ alwaysOn }: Props) => {
  const changeLanguage = useChangeLanguage();
  const t = useTranslate('common');
  const locale = useLocale();
  const { allLocales } = useTenant();

  const options = allLocales.map((el) => {
    return {
      value: el,
      label: localeMap[el] || el,
    };
  });

  if (!alwaysOn && options.length < 2) return null;
  return (
    <Formik<LanguageSchema>
      enableReinitialize
      initialValues={{ locale }}
      onSubmit={() => {}}
      validationSchema={toFormikValidationSchema(languageSchema)}
    >
      <Form>
        <SelectInput
          size={'small'}
          variant={'outlined'}
          label={t('language')}
          color={'secondary'}
          name={'locale'}
          options={options}
          onChange={(e) => changeLanguage(e.target.value as Lang)}
          sx={{ minWidth: 100 }}
        />
      </Form>
    </Formik>
  );
};

export default LanguageSelect;
